import { useMemo } from 'react';
import { Option } from '@common-fe/common-fe';

import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks';
import { usePartnersList } from '@/modules/employer/components/Partners/PartnersList/hooks';
import { PlanStatuses } from '@/modules/plan/plan.types';
import { usePlanListQuery } from '@/modules/plan/PlansList/queries';

interface Params {
  searchString: string;
  planIds: number[];
  isPlanLoading?: boolean;
}
const useReplenishmentFilterItems = (params: Params) => {
  const {
    observingOrganization: { type, name },
  } = useCurrentOrganization();

  // const isEmployerMode = useMemo(() => type === OrganizationTypes.employer, [type]);
  const isSubsidiaryMode = useMemo(() => type === OrganizationTypes.subsidiary, [type]);
  const { options: subsidiariesOptions, isLoading: isLoadingSubsidiaries } = usePartnersList({
    page: 0,
    perPage: 20,
    searchString: params.searchString || '',
    // status: (hasFilterParams ? filterParamsValues.join(', ') : ''),
    mode: OrganizationTypes.subsidiary,
    disabled: isSubsidiaryMode,
  });
  const { isLoading: isPlansLoading, formattedArrayPlans } = usePlanListQuery(
    null,
    PlanStatuses.ACTIVE,
    params.searchString,
    {
      ids: params.planIds,
      disabled: !params.planIds.length || params.isPlanLoading,
    }
  );
  const planOptions = useMemo(() => {
    const currentOptions: Option[] = formattedArrayPlans.map((item) => ({
      key: item.id,
      value: item.name,
    }));
    return currentOptions;
  }, [formattedArrayPlans]);
  const defaultTitle = useMemo(() => {
    return name;
  }, [name]);

  const isLoading = useMemo(() => {
    return isLoadingSubsidiaries || isPlansLoading;
  }, [isLoadingSubsidiaries, isPlansLoading]);

  return {
    subsidiariesOptions: isSubsidiaryMode ? [] : subsidiariesOptions,
    defaultTitle,
    isLoading,
    planOptions,
    isSubsidiaryMode,
  };
};

export default useReplenishmentFilterItems;
